import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { fetchVehiclesData } from "../../../../store/vehicles/actions";

const VehicleDocumentUpload = ({ vehicleId, existingDocs = [], onClose }) => {
    const dispatch = useDispatch();
    const [docTypes, setDocTypes] = useState([]);
    const [files, setFiles] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchDocTypes = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(
                    `${process.env.REACT_APP_WEB_APP_URL}/api/vehicle-document-types`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (res.data.success) {
                    setDocTypes(res.data.data);
                }
            } catch (error) {
                console.error("Error fetching document types:", error);
                toast.error("Failed to load document types");
            }
        };

        fetchDocTypes();
    }, []);

    const handleFileChange = (docId, side, file) => {
        setFiles((prev) => ({
            ...prev,
            [docId]: {
                ...prev[docId],
                [side]: file,
            },
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Object.keys(files).length === 0) {
            toast.warning("Please upload at least one document");
            return;
        }

        setLoading(true);
        const formData = new FormData();

        let index = 0;
        Object.entries(files).forEach(([docId, sides]) => {
            if (sides.front) {
                formData.append(`document[${index}][type_id]`, docId);
                formData.append(`document[${index}][document]`, sides.front);
                formData.append(`document[${index}][view]`, "front");
                formData.append(`document[${index}][vehicle_id]`, vehicleId);
                index++;
            }
            if (sides.back) {
                formData.append(`document[${index}][type_id]`, docId);
                formData.append(`document[${index}][document]`, sides.back);
                formData.append(`document[${index}][view]`, "back");
                formData.append(`document[${index}][vehicle_id]`, vehicleId);
                index++;
            }
        });

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.post(
                `${process.env.REACT_APP_WEB_APP_URL}/api/vehicle-document-upload-multiple`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Documents uploaded successfully!");
                dispatch(fetchVehiclesData());
                onClose();
            } else {
                toast.error("Upload failed");
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Error uploading documents");
        } finally {
            setLoading(false);
        }
    };

    const getExistingDocUrl = (typeId, side) => {
        const doc = existingDocs.find(
        (d) => d.document_type_id === typeId && d.view === side
        );
        return doc ? doc.url : null;
    };

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content rounded-4 shadow-lg">
                    <div className="modal-header">
                        <h5 className="modal-title">Upload Vehicle Documents</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-4">
                                {docTypes.map((doc) => (
                                    <div key={doc.id} className="col-md-6">
                                        <div className="card shadow-sm border-0 h-100">
                                            <div className="card-body">
                                                <h6 className="fw-bold mb-3">{doc.type_name}</h6>

                                                {doc.front_required === 1 && (
                                                    <div className="mb-3 text-center">
                                                        {files[doc.id]?.front ? (
                                                            <img
                                                                src={URL.createObjectURL(files[doc.id].front)}
                                                                alt="preview"
                                                                className="img-fluid rounded mb-2"
                                                                style={{ maxHeight: "150px", objectFit: "cover" }}
                                                            />
                                                        ) : (
                                                            <div className="border p-3 rounded bg-light mb-2">
                                                                <small>No Front Uploaded</small>
                                                            </div>
                                                        )}
                                                        <input
                                                            type="file"
                                                            accept="image/*,.pdf"
                                                            onChange={(e) =>
                                                                handleFileChange(doc.id, "front", e.target.files[0])
                                                            }
                                                        />
                                                    </div>
                                                )}

                                                {doc.back_required === 1 && (
                                                    <div className="mb-3 text-center">
                                                        {files[doc.id]?.back ? (
                                                            <img
                                                                src={URL.createObjectURL(files[doc.id].back)}
                                                                alt="preview"
                                                                className="img-fluid rounded mb-2"
                                                                style={{ maxHeight: "150px", objectFit: "cover" }}
                                                            />
                                                        ) : (
                                                            <div className="border p-3 rounded bg-light mb-2">
                                                                <small>No Back Uploaded</small>
                                                            </div>
                                                        )}
                                                        <input
                                                            type="file"
                                                            accept="image/*,.pdf"
                                                            onChange={(e) =>
                                                                handleFileChange(doc.id, "back", e.target.files[0])
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="text-end mt-4">
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? "Uploading..." : "Upload All"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VehicleDocumentUpload;
